import HeroSlider from "../Components/HeroSlider";
import Intro from "../Components/Intro";
import HeritageCards from "../Components/HeritageCards";
import ArchiveCTA from "../Components/ArchiveCTA";
import SupportBanner from "../Components/SupportBanner";
import ExpodomNotice from "../Components/ExpodomNotice";

export default function HomePage() {
  return (
    <>
      <HeroSlider />
      <Intro />
      <HeritageCards />
      <ExpodomNotice />
      <ArchiveCTA />
      <SupportBanner />
      <img
        src="./barion/EU-Small-nobg-lightmode.png"
        alt="Barion – Biztonságos fizetés"
        className="mx-auto py-2"
      />
      <p className="text-center text-xs text-gray-600 mt-2 max-w-xs mx-auto py-6">
        A fizetés a Barion rendszerén keresztül történik. A bankkártya adatokat nem a szolgáltató,
        hanem a Barion kezeli. A Barion Payment Zrt. a Magyar Nemzeti Bank felügyelete alatt álló
        intézmény, engedélyének száma: H-EN-I-1064/2013. ApplePay csak egyszeri támogatás esetén érhető el.
      </p>
    </>
  );
}
